// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userIdentity: __t.identity().name("user_identity"),
  appId: __t.string().name("app_id"),
  versionId: __t.u64().name("version_id"),
  installPath: __t.string().name("install_path"),
  installedAt: __t.timestamp().name("installed_at"),
});
